import { useInfiniteQuery } from '@tanstack/react-query';
import { useAuth } from '../../../auth/useAuth';
import { chatbotService } from '../../../services/ChatbotService';
import { CHATBOT_CONVERSATION_MESSAGES_PAGE_SIZE } from '../chatbotConstants';
import { chatbotQueryKeys } from '../chatbotQueryKeys';

export function useChatbotConversationMessagesInfiniteQuery(
  chatbotId: string | undefined,
  conversationId: string | undefined,
) {
  const { user } = useAuth();
  const resolvedChatbotId = chatbotId?.trim() ?? '';
  const resolvedConversationId = conversationId?.trim() ?? '';
  const isEnabled =
    Boolean(user) &&
    resolvedChatbotId.length > 0 &&
    resolvedConversationId.length > 0;

  return useInfiniteQuery({
    queryKey: chatbotQueryKeys.conversationMessagesPages(
      resolvedChatbotId,
      resolvedConversationId,
    ),
    enabled: isEnabled,
    initialPageParam: 0,
    queryFn: ({ pageParam }) =>
      chatbotService.listConversationMessages(
        resolvedChatbotId,
        resolvedConversationId,
        {
          limit: CHATBOT_CONVERSATION_MESSAGES_PAGE_SIZE,
          offset: pageParam,
        },
      ),
    getNextPageParam: (lastPage, _allPages, lastPageParam) =>
      lastPage.length === CHATBOT_CONVERSATION_MESSAGES_PAGE_SIZE
        ? (lastPageParam as number) + CHATBOT_CONVERSATION_MESSAGES_PAGE_SIZE
        : undefined,
  });
}
